// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"167":"detail","177":"home"}[chunkId] || chunkId) + "." + {"102":"52f33b86","107":"ed914e7a","111":"7abe316f","167":"fddd5f37","177":"61b270e7","267":"8f93a19c","372":"430cd4fa","561":"175bc9fc","567":"fc8f9075","734":"8107375c","814":"f473716b"}[chunkId] + ".js";
};